Ext.define('SA.Blob', {
    singleton: true,

    toDataUri(blob) {
        return new Promise(resolve => {
            var fileReader = new FileReader();
            fileReader.onload = () => resolve(fileReader.result);
            fileReader.readAsDataURL(blob);
        });
    }
});